import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

// Small arcade/neon "BETA" corner badge — hidden on splash and root redirect.
export const BetaBadge = () => {
  const loc = useLocation();
  if (loc.pathname === "/splash" || loc.pathname === "/") return null;
  return (
    <div
      data-testid="beta-badge"
      className="fixed top-3 right-3 sm:top-4 sm:right-4 z-50 pointer-events-none"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.6, rotate: -20 }}
        animate={{ opacity: 1, scale: 1, rotate: 8 }}
        transition={{ type: "spring", stiffness: 260, damping: 18, delay: 0.3 }}
        className="relative"
      >
        <div
          className="font-display text-xs sm:text-sm tracking-[0.35em] px-2.5 py-1 rounded-md"
          style={{
            background: "linear-gradient(135deg, #FF107A 0%, #FF338F 100%)",
            color: "#FDFBF7",
            border: "1.5px solid #FDFBF7",
            boxShadow:
              "0 0 12px rgba(255,16,122,0.7), 0 0 32px rgba(255,16,122,0.35), inset 0 0 6px rgba(255,255,255,0.25)",
            textShadow: "0 0 6px rgba(255,255,255,0.55)",
          }}
        >
          BETA
        </div>
        <span className="absolute -top-0.5 -left-0.5 w-1 h-1 rounded-full bg-[#FDFBF7]/80" />
        <span className="absolute -top-0.5 -right-0.5 w-1 h-1 rounded-full bg-[#FDFBF7]/80" />
        <span className="absolute -bottom-0.5 -left-0.5 w-1 h-1 rounded-full bg-[#FDFBF7]/80" />
        <span className="absolute -bottom-0.5 -right-0.5 w-1 h-1 rounded-full bg-[#FDFBF7]/80" />
      </motion.div>
    </div>
  );
};
